<div class="work-item-body">
  <span class="work-item-chip">{{ chipLabel() }}</span>
  <p
    class="work-item-lead muted"
    *ngIf="item.why && !(detail()?.freshness?.paragraphs?.length) && !detail()?.intentPlacement && !detail()?.technical && !detail()?.technicalItems?.length && !detail()?.internalLinkItems?.length && !detail()?.supportingGaps?.length"
  >{{ item.why }}</p>

  <ng-container *ngIf="hasStructuredBody(); else legacyBody">
    <ng-container *ngIf="detail() as d">
      <ng-container *ngIf="d.intentPlacement as ip">
        <p class="work-item-line">
          Strongest
          <strong class="work-item-term">{{ ip.familyBold }}</strong
          >{{ ip.familySuffix }} match in your content is lower down the page, under “{{ ip.sectionLabel }}”.
          Consider moving that answer up.
        </p>
        <div class="work-item-examples" *ngIf="ip.passage">
          <ul class="work-item-examples-list">
            <li>
              <strong class="work-item-term">{{ ip.sectionLabel }}</strong>
              <span class="work-item-example-text"> — “{{ ip.passage }}”</span>
            </li>
          </ul>
        </div>
      </ng-container>

      <ng-container *ngIf="d.freshness?.paragraphs?.length">
        <p class="work-item-line" *ngFor="let para of freshnessParagraphs()">{{ para }}</p>
      </ng-container>

      <ng-container *ngIf="d.internalLinkItems?.length">
        <div class="work-item-link-block" *ngFor="let link of d.internalLinkItems">
          <div class="internal-link-row-chips" *ngIf="link.direction || link.score != null">
            <span
              class="internal-link-direction-chip"
              *ngIf="link.direction"
              [ngClass]="internalLinkDirectionChipClasses(link.direction)"
              >{{ internalLinkDirectionChip(link.direction) }}</span
            >
            <span class="internal-link-relevance-chip" *ngIf="link.score != null"
              >Relevance {{ formatInternalLinkScore(link.score) }}</span
            >
          </div>
          <p class="work-item-line" *ngIf="!link.direction && link.anchor">
            <span class="work-item-line-label">Link:</span>
            <strong class="work-item-term">{{ link.anchor }}</strong>
            <span *ngIf="link.targetPath"> → {{ link.targetPath }}</span>
          </p>
          <p class="work-item-line muted" *ngIf="!link.direction && link.sourcePath && link.onThisPage === false">
            <span class="work-item-line-label">Edit on:</span> {{ link.sourcePath }}
          </p>
          <p class="work-item-line" *ngIf="link.direction && (link.pagePath || link.targetPath)">
            <a
              class="work-item-page-link"
              [href]="link.pageUrl || link.targetUrl"
              target="_blank"
              rel="noopener noreferrer"
              >{{ link.pagePath || link.targetPath }}</a
            >
          </p>
          <p class="work-item-placement muted" *ngIf="link.sentence">
            <ng-container *ngIf="link.placementParts as parts; else workItemPlacementPlain">
              “{{ parts.before }}<a
                class="work-item-placement-link"
                [href]="link.linkHref || link.targetUrl"
                target="_blank"
                rel="noopener noreferrer"
                >{{ parts.anchor }}</a
              >{{ parts.after }}”
            </ng-container>
            <ng-template #workItemPlacementPlain>“{{ link.sentence }}”</ng-template>
          </p>
        </div>
      </ng-container>

      <ng-container *ngIf="supportingGapBlocks().length">
        <div class="work-item-supporting-block" *ngFor="let block of supportingGapBlocks()">
          <ng-container [ngSwitch]="block.kind">
            <ng-container *ngSwitchCase="'section'">
              <p class="work-item-line">
                Your competitor has a similar page
                <a
                  class="work-item-gap-url"
                  *ngIf="block.competitorUrl"
                  [href]="block.competitorUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ competitorPageLinkLabel(block.competitorUrl) }}</a
                ><span *ngIf="block.competitorUrl">,</span>
                but they cover the topic more deeply because they have the following sections you don't have:
              </p>
              <ul class="work-item-section-tree" *ngIf="block.sectionTree?.length">
                <ng-container
                  *ngTemplateOutlet="sectionTreeNodes; context: { $implicit: block.sectionTree, depth: 0 }"
                ></ng-container>
              </ul>
            </ng-container>
            <ng-container *ngSwitchCase="'page'">
              <p class="work-item-line">{{ block.intro }}</p>
              <ul class="work-item-gap-pages">
                <li *ngFor="let url of block.pageUrls">
                  <a
                    class="work-item-gap-url"
                    [href]="url"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ competitorPagePath(url) }}</a
                  >
                </li>
              </ul>
            </ng-container>
            <ng-container *ngSwitchCase="'list_tool'">
              <p class="work-item-line">{{ block.intro }}</p>
              <p class="work-item-line">
                <strong class="work-item-missing-topic">{{ block.items[0] }}</strong>
              </p>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="!d.freshness?.paragraphs?.length && !d.intentPlacement && !d.technical && !d.technicalItems?.length && !d.internalLinkItems?.length && !d.supportingGaps?.length">
        <p class="work-item-line" *ngIf="d.missing?.length">
          <span class="work-item-line-label">Missing phrases:</span>
          <ng-container *ngFor="let term of d.missing; let last = last">
            <strong class="work-item-term">{{ term }}</strong><span *ngIf="!last">, </span>
          </ng-container>
        </p>
        <p class="work-item-line" *ngIf="d.misaligned?.length">
          <span class="work-item-line-label">Wrong context:</span>
          <ng-container *ngFor="let term of d.misaligned; let last = last">
            <strong class="work-item-term">{{ term }}</strong><span *ngIf="!last">, </span>
          </ng-container>
        </p>

        <div class="work-item-examples" *ngIf="examples().length">
          <p class="work-item-line-label">Examples:</p>
          <ul class="work-item-examples-list">
            <li *ngFor="let ex of examples()">
              <strong class="work-item-term">{{ ex.term }}</strong>
              <span class="work-item-example-text" *ngFor="let line of ex.lines"> — {{ line }}</span>
            </li>
          </ul>
        </div>

        <p class="work-item-line" *ngIf="d.anchor && d.targetPath">
          <span class="work-item-line-label">Link:</span>
          <strong class="work-item-term">{{ d.anchor }}</strong>
          <span> → {{ d.targetPath }}</span>
        </p>
        <blockquote class="work-item-quote muted" *ngIf="d.sentence">“{{ d.sentence }}”</blockquote>
        <p class="work-item-line muted" *ngIf="d.placement">
          <span class="work-item-line-label">Where:</span> {{ d.placement }}
        </p>

        <ul class="work-item-gap-pages" *ngIf="d.gapPages?.length && !d.supportingGaps?.length">
          <li *ngFor="let page of d.gapPages">
            <a
              class="work-item-gap-url"
              [href]="page.url"
              target="_blank"
              rel="noopener noreferrer"
              >{{ page.url }}</a
            >
            <span class="work-item-gap-sep"> — Missing topic: </span>
            <strong class="work-item-missing-topic">{{ page.missingTopic }}</strong>
          </li>
        </ul>

        <ul class="work-item-pages" *ngIf="d.pages?.length && !d.gapPages?.length">
          <li *ngFor="let page of d.pages">
            <strong>{{ page.label }}</strong>
            <span class="muted" *ngIf="page.topics"> · {{ page.topics }}</span>
          </li>
        </ul>

        <ul class="work-item-bullets" *ngIf="d.bullets?.length">
          <li *ngFor="let b of d.bullets">{{ b }}</li>
        </ul>
      </ng-container>

      <ng-container *ngIf="d.technicalItems?.length">
        <div class="work-item-technical-block" *ngFor="let tech of d.technicalItems">
          <p class="work-item-line">
            <strong class="work-item-term">{{ technicalIssueTitle(tech.title) }}</strong>
          </p>
          <p class="work-item-line muted" *ngIf="technicalGuidance(tech.title) as guidance">{{ guidance }}</p>
          <ul class="work-item-bullets" *ngIf="tech.details?.length">
            <li *ngFor="let line of tech.details">{{ line }}</li>
          </ul>
        </div>
      </ng-container>

      <ng-container *ngIf="!d.technicalItems?.length && d.technical as tech">
        <p class="work-item-line">
          <strong class="work-item-term">{{ technicalIssueTitle(tech.title) }}</strong>
        </p>
        <p class="work-item-line muted" *ngIf="technicalGuidance(tech.title) as guidance">{{ guidance }}</p>
        <ul class="work-item-bullets" *ngIf="tech.details?.length">
          <li *ngFor="let line of tech.details">{{ line }}</li>
        </ul>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #sectionTreeNodes let-nodes let-depth="depth">
    <li class="work-item-section-tree-item" *ngFor="let node of nodes">
      <div class="work-item-section-tree-row">
        <span class="work-item-heading-level-chip" *ngIf="sectionHeadingLevelChip(node.level) as chip">{{
          chip
        }}</span>
        <span class="work-item-section-tree-heading" [class.work-item-missing-topic]="node.isGap">{{
          node.heading
        }}</span>
      </div>
      <ul class="work-item-section-tree" *ngIf="node.children.length">
        <ng-container
          *ngTemplateOutlet="sectionTreeNodes; context: { $implicit: node.children, depth: depth + 1 }"
        ></ng-container>
      </ul>
    </li>
  </ng-template>

  <ng-template #legacyBody>
    <p class="work-item-line" *ngIf="item.changeSummary">{{ item.changeSummary }}</p>
    <pre class="work-item-legacy-detail muted" *ngIf="item.actionDetail">{{ item.actionDetail }}</pre>
  </ng-template>
</div>
